/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline. Keeping your custom
* Javascript in this file will make it easier to update Pipeline.
*/

(function () {

  // --- FORCE aria-expanded to match Pipeline's accordion-is-open class ---
  function desiredExpanded(btn) {
    return btn.classList.contains('accordion-is-open') ? 'true' : 'false';
  }

  function enforceAriaExpanded(btn) {
    if (!btn || !btn.matches || !btn.matches('button[data-accordion-trigger]')) return;

    var want = desiredExpanded(btn);
    if (btn.getAttribute('aria-expanded') !== want) {
      btn.setAttribute('aria-expanded', want);
    }
  }

  function enforceAll() {
    var btns = document.querySelectorAll('button[data-accordion-trigger]');
    for (var i = 0; i < btns.length; i++) {
      enforceAriaExpanded(btns[i]);
    }
  }

  // Initial pass
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enforceAll);
  } else {
    enforceAll();
  }

  // Observe class + aria-expanded changes, then enforce AFTER Pipeline writes
  var obs = new MutationObserver(function (mutations) {
    var buttonsToFix = [];

    for (var i = 0; i < mutations.length; i++) {
      var el = mutations[i].target;
      if (el && el.matches && el.matches('button[data-accordion-trigger]')) {
        // avoid duplicates without Set
        if (buttonsToFix.indexOf(el) === -1) buttonsToFix.push(el);
      }
    }

    if (!buttonsToFix.length) return;

    requestAnimationFrame(function () {
      for (var j = 0; j < buttonsToFix.length; j++) {
        enforceAriaExpanded(buttonsToFix[j]);
      }

      setTimeout(function () {
        for (var k = 0; k < buttonsToFix.length; k++) {
          enforceAriaExpanded(buttonsToFix[k]);
        }
      }, 0);
    });
  });

  obs.observe(document.documentElement, {
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'aria-expanded']
  });


 // Pipeline fix: "Show more" should move focus to the first newly revealed checkbox
(function () {
  if (window.__pipelineShowMoreFocusFix) return;
  window.__pipelineShowMoreFocusFix = true;

  function isVisible(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }

  function revealOptions(group) {
    // Pipeline uses option holders + "is-hidden"
    var hidden = group.querySelectorAll('[data-option-holder].is-hidden');
    for (var i = 0; i < hidden.length; i++) {
      hidden[i].classList.remove('is-hidden');
    }
    return hidden;
  }

  function focusFirstNewlyRevealed(hiddenItems) {
    if (!hiddenItems || !hiddenItems.length) return;

    // First newly revealed item should now be visible
    var targetItem = hiddenItems[0];
    if (!isVisible(targetItem)) return;

    var input = targetItem.querySelector('input[type="checkbox"], input[type="radio"]');
    if (!input) return;

    try {
      input.focus({ preventScroll: true });
      targetItem.scrollIntoView({ block: 'nearest' });
    } catch (e) {
      input.focus();
      targetItem.scrollIntoView({ block: 'nearest' });
    }
  }

  // Capture + stopImmediatePropagation prevents Pipeline's built-in handler from running
  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target && event.target.closest ? event.target.closest('[data-show-more]') : null;
      if (!btn) return;

      // Stop Pipeline's handler (this is the key difference)
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();

      var group = btn.closest ? btn.closest('.sidebar__filter__group') : null;
      if (!group) return;

      var newlyRevealed = revealOptions(group);
      focusFirstNewlyRevealed(newlyRevealed);

      // Optional: hide the button once everything is revealed
      // (safe now because focus is moved into the list)
      btn.style.display = 'none';
      btn.setAttribute('aria-hidden', 'true');
      btn.tabIndex = -1;
    },
    true
  );
  })();
  
  // Make active filter "remove" chips real <button> elements while still using Pipeline's AJAX handler
(function () {
  if (window.__pipelineActiveFilterButtonsInit) return;
  window.__pipelineActiveFilterButtonsInit = true;

  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest ? event.target.closest('button[data-filter-update-url][data-url]') : null;
    if (!btn) return;

    event.preventDefault();

    var url = btn.getAttribute('data-url');
    if (!url) return;

    // Create a temporary <a> *inside the same container* so Pipeline's delegated click handler catches it.
    var a = document.createElement('a');
    a.href = url;
    a.setAttribute('data-filter-update-url', '');
    a.style.position = 'absolute';
    a.style.left = '-9999px';
    a.style.width = '1px';
    a.style.height = '1px';
    a.tabIndex = -1;
    a.setAttribute('aria-hidden', 'true');

    // Put it near the button so the existing container listeners see the click
    btn.parentNode.insertBefore(a, btn.nextSibling);

    a.click();

    // Cleanup
    a.parentNode.removeChild(a);
    }, true);

})();

(function () {

  // --- Remove aria-haspopup from accordion trigger buttons (Pipeline adds it) ---
  function stripAriaHaspopup(btn) {
    if (!btn || !btn.matches || !btn.matches('button[data-accordion-trigger]')) return;
    if (btn.hasAttribute('aria-haspopup')) {
      btn.removeAttribute('aria-haspopup');
    }
  }

  function stripAllAriaHaspopup() {
    document.querySelectorAll('button[data-accordion-trigger]').forEach(stripAriaHaspopup);
  }

  // Initial pass
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stripAllAriaHaspopup);
  } else {
    stripAllAriaHaspopup();
  }

  // Keep stripping in case theme JS re-adds it on toggle / AJAX updates
  var obs = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];

      // attribute changes like aria-haspopup being added back
      if (m.type === 'attributes' && m.attributeName === 'aria-haspopup') {
        stripAriaHaspopup(m.target);
      }

      // newly injected nodes (AJAX / section reload)
      if (m.type === 'childList' && m.addedNodes && m.addedNodes.length) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;

          if (node.matches && node.matches('button[data-accordion-trigger]')) {
            stripAriaHaspopup(node);
          }

          var nested = node.querySelectorAll
            ? node.querySelectorAll('button[data-accordion-trigger]')
            : [];
          nested.forEach(stripAriaHaspopup);
        });
      }
    }
  });

  obs.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['aria-haspopup']
  });

})();

/**
 * ACCESSIBILITY PATCH – ALLYANT #214
 *
 * Removes dynamically-injected ARIA attributes (aria-haspopup, aria-expanded,
 * aria-controls) from mobile navigation ".sliderow" buttons.
 *
 * The theme’s sliderule JS adds these attributes automatically, but they are
 * unnecessary and cause incorrect / confusing announcements in screen readers
 * (NVDA, JAWS), triggering Allyant issue #214.
 *
 * This script:
 * - Strips the attributes on initial load
 * - Watches the mobile drawer via MutationObserver
 * - Removes them again if the theme re-injects them
 *
 * Do NOT remove unless mobile nav accessibility is re-tested with screen readers.
 */

(function () {
  function stripUnneededSliderowAria(root) {
    root = root || document;

    var btns = root.querySelectorAll('button.sliderow');
    for (var i = 0; i < btns.length; i++) {
      btns[i].removeAttribute('aria-haspopup');
      btns[i].removeAttribute('aria-expanded');
      btns[i].removeAttribute('aria-controls');
    }
  }

  function initSliderowAriaStripper() {
    // Initial pass
    stripUnneededSliderowAria(document);

    // Watch the mobile drawer/menu area for JS injecting aria-* attributes later
    var drawer = document.querySelector('#header-menu, .header__drawer, .drawer, nav.drawer');
    if (!drawer) return;

    var mo = new MutationObserver(function (mutations) {
      for (var m = 0; m < mutations.length; m++) {
        var mut = mutations[m];

        // If a sliderow button got aria-* injected, strip it
        if (mut.type === 'attributes' && mut.target && mut.target.matches && mut.target.matches('button.sliderow')) {
          mut.target.removeAttribute('aria-haspopup');
          mut.target.removeAttribute('aria-expanded');
          mut.target.removeAttribute('aria-controls');
        }

        // If new nodes were added (submenu panels rendered), strip within them
        if (mut.type === 'childList' && (mut.addedNodes && mut.addedNodes.length)) {
          stripUnneededSliderowAria(drawer);
          break;
        }
      }
    });

    mo.observe(drawer, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['aria-haspopup', 'aria-expanded', 'aria-controls']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSliderowAriaStripper);
  } else {
    initSliderowAriaStripper();
  }
})();

/**
 * ACCESSIBILITY PATCH – ALLYANT #212
 *
 * Removes unnecessary aria-expanded from the mobile drawer CLOSE button.
 * This button is not a disclosure widget; aria-expanded causes confusing
 * screen reader announcements (e.g., "expanded") for a simple Close action.
 *
 * We intentionally target ONLY the close button to avoid impacting other
 * controls (e.g., the hamburger/open button) that may legitimately use
 * aria-expanded.
 *
 * Do NOT remove unless re-tested with screen readers.
 */
(function () {
  function stripCloseExpanded(root) {
    root = root || document;

    // Target ONLY the drawer close button(s)
    var closeBtns = root.querySelectorAll('button.drawer__close');
    for (var i = 0; i < closeBtns.length; i++) {
      closeBtns[i].removeAttribute('aria-expanded');
    }
  }

  function initCloseExpandedStripper() {
    // Initial pass
    stripCloseExpanded(document);

    // Watch header/drawer for theme re-injecting aria-expanded
    var scope =
      document.querySelector('#header-menu') ||
      document.querySelector('nav.drawer') ||
      document.querySelector('.header__drawer') ||
      document.querySelector('header');

    if (!scope) return;

    var mo = new MutationObserver(function (mutations) {
      for (var m = 0; m < mutations.length; m++) {
        var mut = mutations[m];

        // If aria-expanded gets added to the close button, remove it.
        if (
          mut.type === 'attributes' &&
          mut.target &&
          mut.target.matches &&
          mut.target.matches('button.drawer__close')
        ) {
          mut.target.removeAttribute('aria-expanded');
        }

        // If drawer markup is re-rendered, strip again.
        if (mut.type === 'childList' && mut.addedNodes && mut.addedNodes.length) {
          stripCloseExpanded(scope);
          break;
        }
      }
    });

    mo.observe(scope, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['aria-expanded']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCloseExpandedStripper);
  } else {
    initCloseExpandedStripper();
  }
})();

/**
 * A11Y FIX (#149): Prevent focus from leaving an open modal dialog.
 * Allyant flagged that keyboard users can Tab to elements behind the video modal.
 * This focus-trap keeps Tab/Shift+Tab cycling within the open modal, and marks
 * the page behind the modal as inert so background controls cannot be focused.
 */
(function () {
  var activeTrap = null;

  function getFocusable(container) {
    if (!container) return [];
    var selectors = [
      'a[href]',
      'area[href]',
      'button:not([disabled])',
      'input:not([disabled]):not([type="hidden"])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      'iframe',
      '[tabindex]:not([tabindex="-1"])',
      '[contenteditable="true"]'
    ].join(',');
    return Array.prototype.slice.call(container.querySelectorAll(selectors))
      .filter(function (el) {
        // Only keep elements that are actually visible/focusable
        return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
      });
  }

  function setInertBehindModal(modal, makeInert) {
    // Try to target common Shopify wrappers first
    var candidates = [];
    var main = document.querySelector('main');
    var header = document.querySelector('header');
    var footer = document.querySelector('footer');

    if (header) candidates.push(header);
    if (main) candidates.push(main);
    if (footer) candidates.push(footer);

    // Fallback: inert all body children except the modal itself
    if (!candidates.length) {
      candidates = Array.prototype.slice.call(document.body.children)
        .filter(function (el) { return el !== modal && !el.contains(modal); });
    }

    candidates.forEach(function (el) {
      if (makeInert) {
        // Save previous aria-hidden so we can restore correctly
        if (!el.hasAttribute('data-prev-aria-hidden')) {
          var prev = el.getAttribute('aria-hidden');
          el.setAttribute('data-prev-aria-hidden', prev === null ? '' : prev);
        }
        el.setAttribute('aria-hidden', 'true');

        // inert is supported in modern Chromium/FF/Safari; safe to set regardless
        el.inert = true;
        el.setAttribute('data-a11y-inert', 'true');
      } else if (el.getAttribute('data-a11y-inert') === 'true') {
        el.inert = false;
        el.removeAttribute('data-a11y-inert');

        // Restore aria-hidden
        var prevVal = el.getAttribute('data-prev-aria-hidden');
        el.removeAttribute('data-prev-aria-hidden');
        if (prevVal === '') el.removeAttribute('aria-hidden');
        else el.setAttribute('aria-hidden', prevVal);
      }
    });
  }

  function trapFocus(modal) {
    if (!modal) return;

    var previouslyFocused = document.activeElement;

    function onKeyDown(e) {
      if (e.key !== 'Tab') return;

      var focusables = getFocusable(modal);
      if (!focusables.length) {
        e.preventDefault();
        modal.focus();
        return;
      }

      var first = focusables[0];
      var last = focusables[focusables.length - 1];

      // If focus somehow escaped, pull it back in.
      if (!modal.contains(document.activeElement)) {
        e.preventDefault();
        first.focus();
        return;
      }

      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    function activate() {
      // Ensure the modal itself can be focused as a fallback
      if (!modal.hasAttribute('tabindex')) modal.setAttribute('tabindex', '-1');

      setInertBehindModal(modal, true);

      // Focus the first focusable thing (close button is ideal), else modal root
      var focusables = getFocusable(modal);
      (focusables[0] || modal).focus();

      document.addEventListener('keydown', onKeyDown, true);

      activeTrap = function cleanup() {
        document.removeEventListener('keydown', onKeyDown, true);
        setInertBehindModal(modal, false);

        // Restore focus to what opened the modal if it still exists
        if (previouslyFocused && previouslyFocused.focus) previouslyFocused.focus();
        activeTrap = null;
      };
    }

    activate();
  }

  function isOpenModal(el) {
    // MicroModal usually toggles aria-hidden and/or adds "is-open"
    return el && el.classList && el.classList.contains('modal') &&
      (el.classList.contains('is-open') || el.getAttribute('aria-hidden') === 'false');
  }

  function findOpenModal() {
    var modals = document.querySelectorAll('.modal');
    for (var i = 0; i < modals.length; i++) {
      if (isOpenModal(modals[i])) return modals[i];
    }
    return null;
  }

  // Watch for modal open/close changes
  var observer = new MutationObserver(function () {
    var openModal = findOpenModal();

    if (openModal && !activeTrap) {
      trapFocus(openModal);
    }

    if (!openModal && activeTrap) {
      activeTrap();
    }
  });

  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class', 'aria-hidden'],
    subtree: true
  });

  // Also close trap if user clicks an overlay/close control
  document.addEventListener('click', function (e) {
    if (!activeTrap) return;
    var openModal = findOpenModal();
    if (!openModal) return;

    // MicroModal uses data-micromodal-close on overlay & close button
    if (e.target && e.target.closest && e.target.closest('[data-micromodal-close]')) {
      // Let MicroModal close it first; observer will cleanup.
      // (No-op here intentionally.)
    }
  }, true);
})();

})();


